import React from 'react'
import ReactSlider from 'react-slider'
import styles from './AudioSlider.module.scss'

export const AudioSlider = ({
    value,
    onChange,
}: {
    value: number
    onChange: (value: number) => void
}) => (
    <ReactSlider
        max={1}
        min={0}
        onChange={onChange}
        renderThumb={(props) => <div {...props}></div>}
        step={0.01}
        thumbClassName={styles.sliderThumb}
        trackClassName={styles.sliderTrack}
        value={value}
    />
)
